import { useTheme } from '@daily/shared/contexts/Theme';
import { useLocalSessionId, useNetwork } from '@daily-co/daily-react';
import { useState } from 'react';

import { useShowNames } from '../../lib/state/custom';
import { Tile } from '../Tile';

interface Props extends React.ComponentProps<typeof Tile> {
  fitToRatio?: boolean;
}

export const ScreenPinTile: React.FC<React.PropsWithChildren<Props>> = ({
  aspectRatio: initialRatio,
  fitToRatio = false,
  isScreen = false,
  onVideoResize,
  sessionId,
  style = {},
  ...props
}) => {
  const { colors } = useTheme();
  const [ratio, setRatio] = useState(initialRatio);
  const [showNames] = useShowNames();

  const { threshold } = useNetwork();

  const localSessionId = useLocalSessionId();
  const isLocal = sessionId === localSessionId;

  const handleVideoResize = (aspectRatio: number) => {
    if (!fitToRatio) return;
    setRatio(aspectRatio);
    onVideoResize?.(aspectRatio);
  };

  if (isScreen) {
    return (
      <Tile
        ignoreAspectRatio
        isScreen
        sessionId={sessionId}
        onVideoResize={handleVideoResize}
        style={{
          ...style,
          background: colors.custom.mainAreaBg,
        }}
        {...props}
      />
    );
  }

  return (
    <Tile
      aspectRatio={ratio}
      network={isLocal ? threshold : null}
      onVideoResize={handleVideoResize}
      sessionId={sessionId}
      showNames={showNames}
      {...props}
    />
  );
};
